import axios from "axios";
import { useMutation } from "react-query";
import { IZoneInventory } from "../../../components/FacilityManager/Domain/Types/FloorPlan/ZoneInventory.type";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

/** fetch zone inventory data by mutation */
export function useRemoteFetchZoneInventory() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (zoneInventoryId: number) => {
      const response = await axios.get<IZoneInventory>(`/inventory/zone/${zoneInventoryId}`);
      return response.data;
    },
    onError: () => {
      enqueueSnackbar(t("Failed to fetch zone inventory"), { variant: "error" });
    }
  });
}
